import filter from 'lodash/filter'

export function isSurvey(question) {
	if(question && question.choices) {
		if(filter(question.choices, { 'correct': true }).length !== 0) {
			return false
		} else return true
	} else return null 
} 